import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useMemo, useState } from "react";
import { fetchData, toAbsoluteMedia } from "../../api/api";
import "./PortfolioSection.css";

const PortfolioSection = () => {
  const [webProjects, setWebProjects] = useState([]);
  const [mobileProjects, setMobileProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setErr("");
      try {
        const data = await fetchData("/projects/list/");

        const web = [];
        const mobile = [];

        (data || []).forEach((p) => {
          const cat = (p.category || p.type || "").toLowerCase(); // used only to split
          const item = {
            title: p.title || "",
            // show short_description text on the card (not category)
            short_description:
              p.short_description || p.shortDescription || "",
            project_link: p.project_link || "#",
            img: toAbsoluteMedia(p.image || p.img || ""),
          };

          if (cat.includes("mobile")) {
            mobile.push(item);
          } else {
            // treat all non-mobile as website
            web.push(item);
          }
        });

        if (!alive) return;
        setWebProjects(web);
        setMobileProjects(mobile);
      } catch (e) {
        if (!alive) return;
        setErr("Failed to load projects. Please try again.");
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  const hasData = useMemo(
    () => webProjects.length > 0 || mobileProjects.length > 0,
    [webProjects, mobileProjects]
  );

  return (
    <section className="section-five section-five-portfolio overflow-hidden">
      <div className="container">
        <div className="section-headers" style={{ marginBottom: "2rem" }}>
          <p
            className="our-services discover-our-cases"
            data-aos="fade-down"
            style={{ textAlign: "center", fontSize: "20px" }}
          >
            DISCOVER OUR CASES
          </p>
          <div>
            <h2
              className="our-solution latest_project"
              data-aos="fade-down"
              style={{ textAlign: "center" }}
            >
              Latest Projects
            </h2>
          </div>
        </div>

        {/* Loading / Error / Empty states */}
        {loading && <p data-aos="fade-up">Loading projects…</p>}
        {!loading && err && <p data-aos="fade-up">{err}</p>}
        {!loading && !err && !hasData && (
          <p data-aos="fade-up">No projects available.</p>
        )}

        {/* Website Projects */}
        {!loading && !err && webProjects.length > 0 && (
          <>
            <h2 className="section-title" data-aos="fade-down">
              Websites
            </h2>
            <div className="portfolio-grid">
              {webProjects.map((project, index) => (
                <a
                  key={`web-${index}`}
                  href={project.project_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="portfolio-item"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="portfolio-image-container">
                    <img
                      className="portfolio-img"
                      src={project.img || "/placeholder.svg"}
                      alt={project.title}
                      onError={(e) => (e.currentTarget.src = "/placeholder.svg")}
                    />
                    <div className="portfolio-overlay">
                      <span>View Project</span>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <p className="portfolio-category">
                      {project.short_description}
                    </p>
                    <h3 className="portfolio-title">{project.title}</h3>
                  </div>
                </a>
              ))}
            </div>
          </>
        )}

        {/* Mobile Projects */}
        {!loading && !err && mobileProjects.length > 0 && (
          <div className="mobile-section">
            <h2 className="section-title" data-aos="fade-down">
              Mobile Apps
            </h2>
            <div className="portfolio-grid">
              {mobileProjects.map((project, index) => (
                <a
                  key={`mobile-${index}`}
                  href={project.project_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="portfolio-item"
                  data-aos="fade-up"
                >
                  <div className="portfolio-image-container">
                    <img
                      className="portfolio-img"
                      src={project.img || "/placeholder.svg"}
                      alt={project.title}
                      onError={(e) => (e.currentTarget.src = "/placeholder.svg")}
                    />
                    <div className="portfolio-overlay">
                      <span>View Project</span>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <p className="portfolio-category">
                      {project.short_description}
                    </p>
                    <h3 className="portfolio-title">{project.title}</h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PortfolioSection;
